(function () {
  var ROOT = ".cart-line-item__bundle-properties";
  var LIST = ".cart-line-item__bundle-properties-list";
  var TOGGLE = ".cart-line-item__bundle-properties-toggle";
  var CLAMPED = "cart-line-item__bundle-properties--clamped";
  var EXPANDED = "cart-line-item__bundle-properties--expanded";

  var teardownByRoot = new WeakMap();
  var flushTimer;
  var cartMoAttached;

  function teardown(root) {
    var fn = teardownByRoot.get(root);
    if (!fn) return;
    fn();
    teardownByRoot.delete(root);
  }

  function bindRoot(root) {
    teardown(root);
    var list = root.querySelector(LIST);
    var toggle = root.querySelector(TOGGLE);
    if (!list || !toggle) return;

    var expanded = root.classList.contains(EXPANDED);
    var labelExpand =
      toggle.getAttribute("data-expand-label") || toggle.dataset.expandLabel || "";
    var labelCollapse =
      toggle.getAttribute("data-collapse-label") || toggle.dataset.collapseLabel || "";

    function syncOverflow() {
      if (expanded) {
        toggle.hidden = false;
        root.classList.add(EXPANDED);
        root.classList.remove(CLAMPED);
        return;
      }
      root.classList.remove(EXPANDED);
      root.classList.add(CLAMPED);
      var csList = getComputedStyle(list);
      var lh = parseFloat(csList.lineHeight);
      if (!lh || !isFinite(lh)) lh = parseFloat(csList.fontSize) * 1.25;
      var lines = parseInt(
        getComputedStyle(root).getPropertyValue("--cart-line-item-properties-line-clamp").trim(),
        10
      );
      if (!lines || lines < 1) lines = 1;
      var overflows =
        list.scrollHeight > list.clientHeight + 1 ||
        list.scrollHeight > lh * lines + 3;
      toggle.hidden = !overflows;
      root.classList.toggle(CLAMPED, overflows);
    }

    function scheduleSync() {
      requestAnimationFrame(syncOverflow);
    }

    function onToggle() {
      expanded = !expanded;
      toggle.setAttribute("aria-expanded", String(expanded));
      toggle.textContent = expanded ? labelCollapse : labelExpand;
      scheduleSync();
    }

    toggle.addEventListener("click", onToggle);

    var ro = new ResizeObserver(scheduleSync);
    ro.observe(list);
    syncOverflow();

    teardownByRoot.set(root, function () {
      ro.disconnect();
      toggle.removeEventListener("click", onToggle);
    });
  }

  function bindAll() {
    document.querySelectorAll(ROOT).forEach(bindRoot);
  }

  function queueBind() {
    clearTimeout(flushTimer);
    flushTimer = setTimeout(function () {
      requestAnimationFrame(bindAll);
    }, 50);
  }

  function observeCartMutations() {
    if (cartMoAttached) return;
    cartMoAttached = true;
    var opts = { childList: true, subtree: true };
    var mo = new MutationObserver(queueBind);
    var drawer = document.getElementById("mini-cart");
    var form = document.getElementById("mini-cart-form");
    var roots = [];
    if (drawer) roots.push(drawer);
    if (form && roots.indexOf(form) === -1) roots.push(form);
    if (!roots.length) mo.observe(document.body, opts);
    else roots.forEach(function (el) {
      mo.observe(el, opts);
    });
  }

  function boot() {
    bindAll();
    observeCartMutations();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.documentElement.addEventListener("Cart:Refresh", queueBind);
})();